// analytics constants

import { DESC } from '@atlassian/jira-common-constants/src/sort-directions.tsx';
import type { IssueTypeSchemeFilter, Page, Project } from './types.tsx';

export const SOURCE_NAME = 'issueTypeSchemeDirectory';
export const ISSUE_TYPE_SCHEMES_TABLE = 'issueTypeSchemesTable';
export const ORDER = Object.freeze({
	ASC: 'asc',
	DESC: 'desc',
});

export const MAX_RESULTS = 10;

export const defaultIssueTypeSchemesFilter: IssueTypeSchemeFilter = {
	pageNumber: 1,
	pageSize: MAX_RESULTS,
	expand: ['projects', 'issueTypes'],
	orderBy: 'name',
	sortDirection: DESC,
};

export const EMPTY_PROJECTS_PAGE: Page<Project> = {
	startAt: 0,
	maxResults: 10,
	values: [],
	total: 0,
	isLast: true,
};

export const PACKAGE_NAME = 'jiraAdminPagesIssueTypeSchemesDirectory';

export const FILTER_CHANGE_ANALYTICS = Object.freeze({
	ACTION: 'changed',
	ACTION_SUBJECT: 'filterSearch',
});
